export { AreasContainer as default } from './areas-container';
